import React, { useEffect, useState } from "react";
import { styled } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import NativeSelect from "@material-ui/core/NativeSelect";
import InputBase from "@material-ui/core/InputBase";
import { Typography } from "@material-ui/core";
import * as CMBYN from "../../constants/api";
const BootstrapInput = styled(InputBase)(({ theme }) => ({
	"label + &": {
		marginTop: theme.spacing(3),
		width: "90%",
	},
	"& .MuiInputBase-input": {
		borderRadius: 4,
		position: "relative",
		backgroundColor: theme.palette.background.paper,
		border: "1px solid #ced4da",
		fontSize: 16,

		padding: "10px 26px 10px 12px",
		transition: theme.transitions.create(["border-color", "box-shadow"]),
		// Use the system font instead of the default Roboto font.
		fontFamily: [
			"-apple-system",
			"BlinkMacSystemFont",
			'"Segoe UI"',
			"Roboto",
			'"Helvetica Neue"',
			"Arial",
			"sans-serif",
			'"Apple Color Emoji"',
			'"Segoe UI Emoji"',
			'"Segoe UI Symbol"',
		].join(","),
		"&:focus": {
			borderRadius: 4,
			borderColor: "#80bdff",
			boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
		},
	},
}));

export default function IrrigationPopup(props) {
	const { fieldDetails, parentPreIrrChange, parentPostIrrChange } = props;
	const [preirrigation, setPreirrigation] = useState(fieldDetails.preirr);
	const [postirrigation, setPostirrigation] = useState(fieldDetails.postirr);
	const [irrigationList, setIrrigationList] = useState([]);

	const handlePreIrrigationChange = (event) => {
		setPreirrigation(event.target.value);
		parentPreIrrChange(event.target.value);
	};
	const handlePostIrrigationChange = (event) => {
		setPostirrigation(event.target.value);
		parentPostIrrChange(event.target.value);
	};

	useEffect(() => {
		fetch(CMBYN.FETCH_PREIRRTYPES)
			.then((response) => response.json())
			.then((results) => {
				var list = [];
				for (var u = 0; u < results.length; u++) {
					let usr = results[u];
					if (usr) {
						let option = {};
						option.name = usr.name;
						option.id = usr.id;
						list.push(option);
					}
				}
				setIrrigationList(list);
			});
	}, []);

	const irrigationPeriods = {
		Pre: {
			value: preirrigation,
			changeHandler: handlePreIrrigationChange,
			selectId: "preIrrigation",
			label: "Select the irrigation method that is currently used on this field.",
		},
		Post: {
			value: postirrigation,
			changeHandler: handlePostIrrigationChange,
			selectId: "postIrrigation",
			label: "Select the irrigation method that will be used after the project is completed.",
		},
	};

	return (
		<div>
			<div
				id="irrigationDataEntryArea"
				style={{ display: "flex", flexDirection: "row", width: "100%", flexWrap: "wrap", gap: 16 }}
			>
				{Object.entries(irrigationPeriods).map(([periodKey, period], idx) => {
					const periodTitle = `${periodKey}-Project`;
					return (
						<React.Fragment key={periodKey}>
							<div
								id={periodTitle}
								style={{ width: 455, display: "flex", flexDirection: "column", justifyContent: "space-between" }}
							>
								<Typography style={{ fontSize: "1.5rem", fontWeight: "400" }}>{periodTitle}</Typography>
								<div style={{ marginTop: "10px" }}>
									<InputLabel variant="standard" htmlFor={period.selectId} color="primary">
										{period.label}
									</InputLabel>
								</div>
								<div style={{ marginTop: "10px" }}>
									<NativeSelect
										id={period.selectId}
										value={period.value}
										onChange={period.changeHandler}
										input={<BootstrapInput />}
									>
										<option value="" disabled>
											Select an option
										</option>
										{irrigationList.map((cr) => (
											<option key={cr.id} value={cr.id}>
												{cr.name}
											</option>
										))}
									</NativeSelect>
								</div>
							</div>
							{idx === 0 && <div className="vertical-divider" />}
						</React.Fragment>
					);
				})}
			</div>
			<style>{`
				.vertical-divider {
					height: auto;
					width: 2px;
					background: #e0e0e0;
					margin: 0 12px;
					align-self: stretch;
				}
				@media (max-width: 1079px) {
					#irrigationDataEntryArea {
						flex-direction: column !important;
					}
					.vertical-divider {
						display: none;
					}
				}
			`}</style>
		</div>
	);
}
